import React from "react";

import Typography from "@mui/material/Typography";
import {COLORS} from "../../../config/constants";

import './declarations_examples_list.scss';
import {formatHSCode} from "../../../utils/helpers";

const DeclarationsExamplesListItem = ({handleApplyCode, code, title, isHelpTab} : DeclarationsExamplesListItemProps) => {

  if (!isHelpTab) {
    return <div className='declarations-examples-list-item'>
      <div className={`declarations-examples-list-item__code${handleApplyCode ? '' : ' declarations-examples-list-item__code_noLink'}`} onClick={() => handleApplyCode?.(code)}>
        <Typography component='span' variant='inherit' sx={{ fontWeight: 700 }} className='declarations-examples-list-item__text'>{formatHSCode(code)}</Typography>
      </div>
      <Typography variant='caption' sx={{ fontWeight: 400, color: COLORS.BLACK, letterSpacing: 0, lineHeight: 1.5, marginLeft: 1 }} className='declarations-examples-list-item__description'>{title}</Typography>
    </div>;
  }

  return <div className='declarations-examples-list-item declarations-examples-list-item_help'>
    <div className='declarations-examples-list-item__code'>
      <Typography
        component={handleApplyCode ? 'button' : 'span'}
        type={handleApplyCode ? 'button' : undefined}
        variant='caption'
        className='declarations-examples-list-item__text'
        sx={{
          color: handleApplyCode ? COLORS.BLUE : COLORS.BLACK_DARK,
          fontSize: '12px',
          fontWeight: 700,
          letterSpacing: 0,
          lineHeight: '18px',
          cursor: handleApplyCode ? 'pointer' : 'default',
          textDecoration: handleApplyCode ? 'underline dotted' : 'none',
        }}
        onClick={() => handleApplyCode?.(code)}
      >
        {formatHSCode(code)}
      </Typography>
    </div>
    <Typography variant='caption' sx={{ fontWeight: 400, color: COLORS.BLACK_DARK, letterSpacing: 0, lineHeight: '18px' }} className='declarations-examples-list-item__description'>
      {title}
    </Typography>
  </div>

}

export default DeclarationsExamplesListItem

